// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"2a38cfab","689":"1a171fcb","764":"21d1bc2c"}[chunkId] + ".chunk.css";
};